import React, { useContext, useRef, useState } from 'react';
import {
  Button,
  Grid,
  IconButton,
  InputLabel,
  Snackbar,
  TextField,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { GlobalContext } from '../../../services/global/GlobalState';
import validator from 'validator';
import * as moment from 'moment-timezone';
import { useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { urlConfig } from '../../../config/urlConfig';
import CloseIcon from '@material-ui/icons/Close';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { ProfileContext } from '../../../services/profile/profile.context';
import { useHistory } from 'react-router-dom';
import CustomPhoneInput from '../../../components/CustomPhoneInput';
import '../components/phone-style.css';
import { ProfileImageContainer } from '../components/profile-image-container';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: '1rem',
  },
  formControl: {
    minWidth: '100%',
  },
  submitBox: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: '24px 16px 24px 0',
    position: 'relative',
  },
  buttonProgress: {
    color: '#000',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export const UserProfile = () => {
  const { user, setUser, changeProfileImage } = useContext(ProfileContext);

  const history = useHistory();

  const classes = useStyles();
  const fnameRef = useRef(null);
  const lnameRef = useRef(null);
  const mobileNumberRef = useRef(null);
  const emailRef = useRef(null);
  const [username, setUsername] = useState('');
  const [firstName, setFirstName] = useState('');
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastName, setLastName] = useState('');
  const [lastNameError, setLastNameError] = useState(false);
  const [birthdate, setBirthdate] = useState(
    user ? moment(user.birthdate).format('YYYY-MM-DD') : null
  );
  const [gender, setGender] = useState(null);
  const [mobileNumber, setMobileNumber] = useState('');
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [mobileNumberHelpertext, setMobileNumberHelpertext] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [open, setOpen] = useState(false);

  const [about, setAbout] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      setOpen(false);
    }
    setOpen(false);
  };

  useEffect(() => {
    if (user) {
      setFirstName(user.first_name);
      setLastName(user.last_name);
      setEmail(user.email);
      setBirthdate(user.birthdate);
      setGender(user.gender ? user.gender : null);
      setMobileNumber(user.phonenumber);
      setUsername(user.username);
      setAbout(user.about_me);
    }
  }, [user]);

  const changeGender = (event) => {
    setGender(event.target.value);
  };
  const changeBirthdate = (date) => {
    setBirthdate(moment(date).format('YYYY-MM-DD'));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    setError('');

    if (validator.isEmpty(firstName)) {
      setFirstNameError(true);
      fnameRef.current.focus();
    }
    if (validator.isEmpty(lastName)) {
      setLastNameError(true);
      if (!validator.isEmpty(firstName)) {
        lnameRef.current.focus();
      }
    }
    if (validator.isEmpty(email)) {
      setEmailError(true);
      if (firstName && lastName !== '') {
        emailRef.current.focus();
      }
    }
    const data = {
      first_name: firstName,
      last_name: lastName,
      birthdate,
      gender: gender ? gender : null,
      email,
      username,
      lat: user.lat,
      lng: user.lng,
      phonenumber: mobileNumber === undefined ? null : mobileNumber,
      about_me: about ? about : null,
    };

    if (firstName && lastName !== '') {
      if (mobileNumber) {
        if (mobileNumber && isValidPhoneNumber(mobileNumber)) {
          changeProfileImage();
          setIsLoading(true);
          axios
            .post(urlConfig.refresh_token_url, {
              refresh: Cookies.get('refresh_token'),
            })
            .then((res) => {
              axios
                .patch(urlConfig.user_url, data, {
                  headers: {
                    Authorization: `Bearer ${res.data.access}`,
                  },
                })
                .then((res) => {
                  setUser(res.data);
                  setOpen(true);
                  setMobileNumberHelpertext('');
                  setMobileNumberError(false);
                  setIsLoading(false);
                  setError('');
                })
                .catch((err) => {
                  setIsLoading(false);
                  console.log(err);
                  if (err.response && err.response.data.about_me) {
                    setError(err.response.data.about_me.toString());
                  } else {
                    setError(err.toString());
                  }
                });
            })
            .catch((err) => {
              setIsLoading(false);
              console.log('refresh token error: ', err.response);
              setError(err.toString());
            });
        } else {
          setMobileNumberError(true);
          setMobileNumberHelpertext('Please enter a valid phone number');
        }
      } else {
        changeProfileImage();
        setMobileNumberHelpertext('');
        setMobileNumberError(false);
        setIsLoading(true);
        axios
          .post(urlConfig.refresh_token_url, {
            refresh: Cookies.get('refresh_token'),
          })
          .then((res) => {
            axios
              .patch(urlConfig.user_url, data, {
                headers: {
                  Authorization: `Bearer ${res.data.access}`,
                },
              })
              .then((res) => {
                setUser(res.data);
                setOpen(true);
                setMobileNumberHelpertext('');
                setMobileNumberError(false);
                setError('');
                setIsLoading(false);
              })
              .catch((err) => {
                setIsLoading(false);
                console.log(
                  'refresh token error: ',
                  err.response.data.about_me
                );
                if (err.response && err.response.data.about_me) {
                  setError(err.response.data.about_me.toString());
                } else {
                  setError(err.toString());
                }
              });
          })
          .catch((err) => {
            setError(err.toString());
            setIsLoading(false);
          });
      }
    }
  };

  return (
    <div className={classes.root}>
      <form onSubmit={submitHandler} noValidate autoComplete='off'>
        <Grid container justifyContent='space-between' spacing={2}>
          <Grid item xs={12}>
            <ProfileImageContainer />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label='First Name'
              value={firstName}
              inputRef={fnameRef}
              onChange={(e) => {
                setFirstName(e.target.value);
                setFirstNameError(false);
              }}
              error={firstNameError}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label='Last Name'
              value={lastName}
              inputRef={lnameRef}
              onChange={(e) => {
                setLastName(e.target.value);
                setLastNameError(false);
              }}
              error={lastNameError}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              disableFuture
              openTo='year'
              fullWidth
              input
              value={birthdate}
              onChange={changeBirthdate}
              format='dd/MM/yyyy'
              label='Date of birth'
              views={['year', 'month', 'date']}
              autoOk
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl className={classes.formControl}>
              <InputLabel>Gender</InputLabel>
              <Select fullWidth value={gender || ''} onChange={changeGender}>
                <MenuItem value=''>
                  <em>prefer not to disclose</em>
                </MenuItem>
                <MenuItem value='F'>Female</MenuItem>
                <MenuItem value='M'>Male</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              type='email'
              label='Email'
              fullWidth
              value={email}
              error={emailError}
              inputRef={emailRef}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label='User name'
              fullWidth
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label='About me'
              onChange={(e) => setAbout(e.target.value)}
              fullWidth
              value={about || ''}
              multiline
            />
          </Grid>
          <Grid item xs={12}>
            <PhoneInput
              fullWidth
              placeholder='Enter phone number'
              value={mobileNumber}
              countrySelectProps={{ unicodeFlags: true }}
              onChange={setMobileNumber}
              inputComponent={CustomPhoneInput}
              error={mobileNumberError}
              helperText={mobileNumberHelpertext}
              inputRef={mobileNumberRef}
            />
          </Grid>
        </Grid>

        <div className={classes.submitBox}>
          <div className={classes.wrapper}>
            <Button
              type='submit'
              color='primary'
              variant='contained'
              className={classes.saveButton}
              size='small'
              disabled={isLoading}
              id='save-profile'
            >
              Save
            </Button>
            {isLoading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
          <Button
            size='small'
            variant='outlined'
            disabled={isLoading}
            onClick={() => history.push('/meetings')}
          >
            Discard Changes
          </Button>
        </div>

        {error && <Typography color='error'>{error}</Typography>}

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={open}
          autoHideDuration={2000}
          onClose={handleClose}
          message='profile has been updated.'
          action={
            <>
              <IconButton
                size='small'
                aria-label='close'
                color='inherit'
                onClick={handleClose}
              >
                <CloseIcon fontSize='small' />
              </IconButton>
            </>
          }
        />
      </form>
    </div>
  );
};
